import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import * as chiffresClesStyles from '../../../styles/widgets/chiffre-cle.module.scss';
import * as styleLink from '../../../styles/communs/polylink.module.scss';
import PolyLink from '../PolyLink';

const ChiffreCle = React.memo(function ChiffreCle ({
  elem,
  column,
  row
}) {
  const {
    label,
    value,
    new_window,
    URL,
  } = elem;

  return (
    <PolyLink
      ariaLabel={label}
      className={clsx(chiffresClesStyles.bloc, {
        [chiffresClesStyles.hover]: URL,
      })}
      dataCy="button-chiffre-cle"
      target={new_window ? '_blank' : '_self'}
      url={URL}
    >
      <div
        style={{
          paddingBottom: `calc((100% / ${column}) * (${row}))`
        }}
      />
      <div className={chiffresClesStyles.root}>
        <div className={chiffresClesStyles.contentRoot}>
          <div className={chiffresClesStyles.figure}>
            <h1
              className={chiffresClesStyles.h1}
            >
              {label}
            </h1>
          </div>
          <div className={chiffresClesStyles.label}>
            <p
              className={clsx(
                chiffresClesStyles.h3Label,
                chiffresClesStyles.h2,
                chiffresClesStyles.nbLines,
                styleLink.withoutIcon
              )}
            >
              {value}
            </p>
          </div>
        </div>
      </div>
    </PolyLink>
  );
});

ChiffreCle.propTypes = {
  column: PropTypes.number,
  elem: PropTypes.shape({
    label: PropTypes.string.isRequired,
    new_window: PropTypes.bool,
    URL: PropTypes.string,
    value: PropTypes.string.isRequired,
  }),
  row: PropTypes.number
};

export default ChiffreCle;
